import {
    SET_SELECTED_CATEGORY_ID,
    SET_ITEM_TO_CART,
    CLEAR_CART_ITEM_ANIMATION,
    SHOW_CART_MODAEL,
} from '../actions/types';

const INITIAL_STATE = {
    selectedCategoryId: null,
    cartItemsToAnimate: [],
    showCartModal: false,
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_SELECTED_CATEGORY_ID:
            return { ...state, selectedCategoryId: action.payload };
        case SET_ITEM_TO_CART:
            if (action.meta && action.meta.animate) {
                return { ...state, cartItemsToAnimate: state.cartItemsToAnimate.concat(action.payload) };
            }
            return state;
        case CLEAR_CART_ITEM_ANIMATION:
            return { ...state, cartItemsToAnimate: state.cartItemsToAnimate.filter(cartItem => cartItem !== action.payload) };
        case SHOW_CART_MODAEL:
            return { ...state, showCartModal: action.payload };
        default:
            return state;
    }
};
